import { IonButton } from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import QRCode from "qrcode";
import { GenerateLinkForQRCode } from "../../services/AuthServices";
import { CreatePatientOnProactiveYou } from "../../services/AuthServices";

interface Props {
  setRegisterPatientModal: (value: boolean) => void;
  patientData?: {
    masterPatientId?: number;
    email?: string;
    mobilePhone?: string;
    firstName?: string;
    lastName?: string;
    fullName?: string;
    patientName?: string;
    dob?: string;
    DOB?: string;
    FirstName?: string;
    LastName?: string;
    PatientLocationId?: number;
  };
  isCalledAfterRtmEnabled?: boolean;
  onError?: (message: string) => void;
}

const PatientRegistrationQRModal: React.FC<Props> = ({
  setRegisterPatientModal,
  patientData: initialPatientData,
  isCalledAfterRtmEnabled = false,
  onError,
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [patientData, setPatientData] = useState(initialPatientData);
  const [patientName, setPatientName] = useState("");
  const [pyAppLink, setPyAppLink] = useState("");
  const [qrData, setQrData] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);

  // Initialize when patientData is available
  useEffect(() => {
    if (patientData && !isInitialized) {
      setIsInitialized(true);
      initialize();
    }
  }, [patientData, isInitialized]);

  // Generate QR code when qrData is available
  useEffect(() => {
    if (qrData && canvasRef.current) {
      generateQRCode();
    }
  }, [qrData]);

  const initialize = () => {
    const name =
      patientData?.fullName !== undefined
        ? patientData.fullName
        : patientData?.patientName;
    setPatientName(name || "");
    generateLink();
  };

  const generateQRCode = () => {
    if (!canvasRef.current) return;

    QRCode.toCanvas(
      canvasRef.current,
      qrData,
      {
        width: 305,
        scale: 8,
        margin: 1,
        errorCorrectionLevel: "L",
      },
      (error) => {
        if (error) {
          console.error("Error generating QR code:", error);
        }
      },
    );
  };

  const generateLink = async () => {
    debugger;
    const request = {
      MasterPatientId:
        patientData?.masterPatientId === 0
          ? JSON.parse(sessionStorage.getItem("selectedPatientMasterId") ?? "0")
          : patientData?.masterPatientId,
      Email: patientData?.email,
      MobilePhone: patientData?.mobilePhone,
      PatientLocationId: patientData?.PatientLocationId,
    };

    try {
      const response = await GenerateLinkForQRCode(request);
      console.log("Link generated successfully", response);
      if (response && response.data && response.data.pyAppLink) {
        setPyAppLink(response.data.pyAppLink);
      }

      await createPatient(response);
    } catch (error) {
      console.error("Error occurred while generating link:", error);
      setErrorMessage("Failed to generate registration link.");
    }
  };

  const createPatient = async (QRResponse: any) => {
    setErrorMessage("");

    const request = {
      FirstName: patientData?.firstName ?? patientData?.FirstName,
      LastName: patientData?.lastName ?? patientData?.LastName,
      Email: patientData?.email,
      MobilePhone: patientData?.mobilePhone,
      DOB: patientData?.dob ?? patientData?.DOB,
      PatientLocationId: patientData?.PatientLocationId,
    };

    try {
      const response = await CreatePatientOnProactiveYou(request);
      console.log("Patient created successfully", response);

      // Check if userCode is not equal to 7
      if (response?.data?.userCode === 8) {
        // Close the current modal first
        setRegisterPatientModal(false);

        // Display error message via callback
        if (onError) {
          onError("Patient exists on multiple locations.");
        }
      } else if (response?.data?.userCode === 6) {
        // Close the current modal first
        setRegisterPatientModal(false);

        // Display error message via callback
        if (onError) {
          onError("Patient exists on multiple locations.");
        }
      } else if (response?.data?.userCode === 5) {
        // Close the current modal first
        setRegisterPatientModal(false);

        // Display error message via callback
        if (onError) {
          onError(
            "Patient already registered. Please use existing login credentials to access Proactive You.",
          );
        }
      } else {
        // usercode 7 means patient is created successfully on proactive you and we can generate QR code
        setQrData(QRResponse.data.pyAppLink);
      }
    } catch (error) {
      console.error("Error occurred while CreatePatientOnProactiveYou:", error);
      setErrorMessage("Patient exists on multiple locations.");
    }
  };

  const handleClose = () => {
    setRegisterPatientModal(false);
    // if (isCalledAfterRtmEnabled && authService.emitRtmStatusChanged) {
    //   authService.emitRtmStatusChanged();
    // }
  };

  return (
    <div className="new-success-modalinner-wrap using-proactive-modal">
      <h1 className="fz-32 fw-700 align-center text-charcoal-blue mb-16">
        {patientName}
      </h1>
      <p className="fz-20 fw-400 align-center text-charcoal-blue mb-24">
        ProactiveYou SignUp QR
      </p>

      {errorMessage && (
        <div
          style={{
            backgroundColor: "#fee",
            color: "#c00",
            padding: "12px",
            marginBottom: "16px",
            borderRadius: "4px",
            textAlign: "center",
          }}
        >
          {errorMessage}
        </div>
      )}

      {qrData ? (
        <>
          <div
            className="qr-code-container"
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "24px",
              backgroundColor: "#fff",
              marginBottom: "24px",
            }}
          >
            <canvas ref={canvasRef}></canvas>
          </div>
        </>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "48px",
            marginBottom: "24px",
          }}
        >
          <p>Generating QR code...</p>
        </div>
      )}

      <IonButton
        placeholder={undefined}
        className="generic-btn mb-0 h-64 fz-26"
        onClick={handleClose}
      >
        Close
      </IonButton>
    </div>
  );
};

export default PatientRegistrationQRModal;
